import { Component, OnInit } from '@angular/core';
import { GTMService } from 'src/app/services/gtm.service';
import { EstablishmentRedirectionService } from 'src/app/services/establishment-redirection.service';
import { Subscription } from 'rxjs/Subscription';
import { Router  } from '@angular/router';
import { environment } from 'src/environments/environment';
import { slugify } from '../../utils/string';

@Component({
  selector: 'establishment-redirection',
  templateUrl: './establishment-redirection.component.html',
  providers: [GTMService],
  styleUrls: ['./establishment-redirection.component.scss'],
})
export class EstablishmentRedirection implements OnInit {
  loading = false;
  loadingSubscription: Subscription;
  campaignLink = '';
  typeRedirection = '';
  dataRedirection: any;
  currentRoute: string;

  constructor(
    private establishmentRedirectionService: EstablishmentRedirectionService,
    private router: Router,
    private gtm: GTMService
    ) {
      this.currentRoute = `${environment.SITE_URL}${router.url.substring(1)}`;
    }

  ngOnInit() {
    this.loadingSubscription = this.establishmentRedirectionService.getLoadingStatus().subscribe((data) => {
      if (data.loading) {
        this.loading = data.loading;
        this.campaignLink = decodeURIComponent(data.campaignLink);
        this.typeRedirection = data.dataRedirection.modalType;
        this.dataRedirection = data.dataRedirection;
      } else {
        this.loading = data.loading;
        if (this.typeRedirection === 'modalCouponWhatsapp') {
          this.openWhatsapp();
        } else {
          this.verifyEventToTracking();
          window.open(this.campaignLink, '_blank');
        }
      }
    });
  }

  openWhatsapp() {
    this.trackingVirtualPageView('cupom-copiado-sucesso');
    // tslint:disable-next-line:max-line-length
    const textToShare = `Olá, sou usuário Allya e gostaria de utilizar o seguinte benefício:\n\n*${this.dataRedirection.partner.offerTitle}*\n${this.currentRoute}\n\nCupom: *${this.dataRedirection.partner.couponCode}*\n___________________________________________\nMeus dados:\nNome: *${this.dataRedirection.user.name}*\n___________________________________________\nMensagem enviada por Allya!`;
    // tslint:disable-next-line:max-line-length
    window.open(`https://api.whatsapp.com/send?phone=55${encodeURIComponent(this.campaignLink)}&text=${encodeURIComponent(textToShare)}`, '_blank');
  }

  verifyEventToTracking() {
    if (this.typeRedirection === 'goToSite') {
      this.trackingEventInteraction('desconto-aplicado:sucesso');
      this.trackingVirtualPageView('desconto-aplicado-sucesso');
    } else if (this.typeRedirection === 'modalCouponRedirect') {
      this.trackingEventInteraction('cupom-copiado:sucesso');
      this.trackingVirtualPageView('desconto-aplicado-sucesso');
    }
  }

  private getSlug() {
    const slug = this.dataRedirection && this.dataRedirection.partner && this.dataRedirection.partner.slug ?
      this.dataRedirection.partner.slug
      : '';

    return slug;
  }

  trackingEventInteraction(eventName: string) {
    const slug = this.getSlug();
    const eventContent: any = {
      event: 'interaction',
      'event-category': 'admin',
      'event-action': `${slugify(slug)}:view`,
      'event-label': `${slugify(eventName)}`,
    };
    this.gtm.sendEvent(eventContent);
  }

  trackingVirtualPageView(pageName: string) {
    const slug = this.getSlug();
    const viewContent: any = {
      event: 'virtualPageView',
      virtualPageView: `vpv/admin/parceiro/${slug}/${pageName}`,
    };
    this.gtm.sendEvent(viewContent);
  }
}
